module.exports = __webpack_public_path__ + "img/digital_wire_top.4b7cee47.svg";